import { useTranslation } from 'react-i18next'

//Components
import ItineraryList from "../../components/MiceContact/ItineraryList"
import Translate from '../../i18n/Translate'

//Images
import miceContactImgMB from '../../assets/images/mice-contact/MICE-contact-img-mb@2x.jpg'
import miceContactImgDT from '../../assets/images/mice-contact/MICE-contact-img-dt@2x.jpg'

//Intersection
import { useInView } from 'react-intersection-observer'


const ListContainer = () => {

    const { t } = useTranslation();

    const [title, inView] = useInView({
        triggerOnce: true,
        threshold: 0.5,
    })

    return (

        <section className="list-container">
            <h2 className={`title animate slide-up ${inView ? 'in-view' : ''}`} ref={title}>
                <Translate langkey="mice.contact.title"/>
            </h2>
            <ItineraryList
            title={t("mice.contact.list1.title")}
            list={["mice.contact.list1.item1", "mice.contact.list1.item2", "mice.contact.list1.item3", "mice.contact.list1.item4", "mice.contact.list1.item5", "mice.contact.list1.item6", "mice.contact.list1.item7", "mice.contact.list1.item8", "mice.contact.list1.item9"]} />
            <ItineraryList
            title={t("mice.contact.list2.title")}
            list={["mice.contact.list2.item1", "mice.contact.list2.item2"]} />
            <ItineraryList
            title={t("mice.contact.list3.title")}
            list={["mice.contact.list3.item1", "mice.contact.list3.item2", "mice.contact.list3.item3", "mice.contact.list3.item4", "mice.contact.list3.item5"]} />
            <ItineraryList
            title={t("mice.contact.list4.title")}
            list={["mice.contact.list4.item1", "mice.contact.list4.item2", "mice.contact.list4.item3"]} />
            <ItineraryList
            title={t("mice.contact.list5.title")}
            list={["mice.contact.list5.item1", "mice.contact.list5.item2", "mice.contact.list5.item3"]} />
            <ItineraryList
            title={t("mice.contact.list6.title")}
            list={["mice.contact.list6.item1", "mice.contact.list6.item2", "mice.contact.list6.item3", "mice.contact.list6.item4", "mice.contact.list6.item5"]} />
            <ItineraryList
            title={t("mice.contact.list7.title")}
            list={["mice.contact.list7.item1"]} />
            <ItineraryList
            title={t("mice.contact.list8.title")}
            list={["mice.contact.list8.item1"]} />
            <ItineraryList
            title={t("mice.contact.list9.title")}
            list={["mice.contact.list9.item1"]} />
            <div className="incoming-mice-contact__img">
                <picture>
                    <source media="(min-width: 768px )" srcSet={`${miceContactImgDT}`} />
                    <img src={miceContactImgMB} alt="Mice Contact" />
                </picture>
            </div>
        </section>
    )
}

export default ListContainer